const buttonsShow = document.querySelectorAll('[map-show-btn]');
const buttonsHide = document.querySelectorAll('[map-hide-btn]');
const detailsContainers = document.querySelectorAll('[data-area-details]');
const basicInfoContainer = document.querySelector('.block-map-show-details__basic-info-wrapper');
const detailsGeneralContainer = document.querySelector('.block-map-show-details__details-wrapper');

// Nowa sekcja
const blockMapShowDetails = document.querySelector('.block-map-show-details .container-lg');

if(blockMapShowDetails) {
    const collapseList = blockMapShowDetails.querySelectorAll('.collapse');

    collapseList.forEach(collapse => {
        collapse.addEventListener('show.bs.collapse', (e)=>{
            const eventSrcBtn = blockMapShowDetails.querySelector(`[data-bs-target='#${e.target.id}']`);
            eventSrcBtn.textContent = eventSrcBtn.dataset.hideText;
        });

        collapse.addEventListener('hide.bs.collapse', (e)=>{
            const eventSrcBtn = blockMapShowDetails.querySelector(`[data-bs-target='#${e.target.id}']`);
            eventSrcBtn.textContent = eventSrcBtn.dataset.showText;
        });

       collapse.addEventListener('shown.bs.collapse', (e)=>{
           let closeAllBtn = blockMapShowDetails.querySelector('.collapse.show button');
           const collapseInstance = bootstrap.Collapse.getInstance(collapse);

           const scrollTo = blockMapShowDetails.querySelector(`#${e.target.id}`)
           scrollTo.scrollIntoView({behavior: "smooth", block: "start"});

           closeAllBtn.addEventListener('click', ()=>{
               blockMapShowDetails.querySelector('.card-group').scrollIntoView({behavior: "smooth", block: "start"});
               collapseInstance.hide();
           });
       });
    });
}
//Nowa sekcja koniec

buttonsShow.forEach((showBtn, index) => {
    let currentContentToShow = document.querySelector(`[data-area-details='${index + 1}']`);
    showBtn.addEventListener('click', () => {
        let isActive = showBtn.classList.contains('active');

        detailsContainers.forEach(container => container.classList.remove('active'));
        buttonsShow.forEach(btn => {
            btn.classList.remove('active');
            btn.textContent = btn.dataset.showText;
        });

        if (isActive) return
        currentContentToShow.classList.add('active');
        showBtn.classList.add('active');
        showBtn.textContent = showBtn.dataset.hideText;

        detailsGeneralContainer.scrollIntoView({behavior: "smooth", block: "start"});
    })
})

buttonsHide.forEach(hideBtn => {
    hideBtn.addEventListener('click', () => {
        detailsContainers.forEach(container => container.classList.remove('active'));
        buttonsShow.forEach(showBtn => {
            showBtn.textContent = showBtn.dataset.showText;
            showBtn.classList.remove('active');
        });

        basicInfoContainer.scrollIntoView({behavior: "smooth", block: "start"});
    })
})